/**
 * Created by lowdev on 1/4/18.
 */
import $ from 'jquery'

import config from '@root/js/api.config'
import Service from './services/Service'
import Calendar from './services/calendar'
import SignatureForm from '@utils/js/signature-form'
import MonthPicker from '@utils/js/month-picker'


let services = {
    staff: new Service(config, 'staff'),
    support: new Service(config, 'support')
}

let itemList = $('#company-list')

if (itemList.length !== 0) {
    itemList.find('.card').find('button').on('click', function() {
        services[$(this).data('key')].remove($(this).data('target')).then(e => {
            $(this).parents('.card').parent().remove()
        })
    })
}

// service.getList().then(staffs => {
//   document.getElementById('staff-list').innerHTML = staffs.map(staff => staff.renderCard()).join('')
// })


$(document).ready(function() {

    if($('#calendar').length == 1)
       new Calendar('#calendar')

    $('.signature-form').each(function(){
        new SignatureForm(this)
    })

    $('.month-picker').each(function(){
        new MonthPicker(this)
    })

    // When the user open the order action modals set the action input
    $('.order-action').each(function(pos, element) {
        $(element).on('click', function() {
            $('#orderActionModal .modal-body').text($(element).data('phrase'));
            $('#orderActionModal .modal-footer button[type="submit"]').attr('class', $(element).data('btn-class'));
            $('#order_action_form').attr('action', '/accounts/pro/order/' + $(element).data('order-id') + '/action/')
            $('#order_action_input').val($(element).data('action'));
        });
    });

    $('.table-conversation .conversation-row').click(function() {
        window.location.href = $(this).find('a').attr('href');
    });

    $('.table-conversation .conversation-row').click(function() {
        window.location.href = $(this).find('a').attr('href');
    });
});



// WEBPACK FOOTER //
// ./accounts/pro/static/js/apps.js